// removed by extract-text-webpack-plugin
module.exports = {"inputForm":"_3XEqjQheijJ7nupmxHh0S4","label":"_1Vv59Luqr47slehw8I_7ez","select":"_1MzTlMk0lQx1Sz5JBx3AeF","option":"_3Oc6WI8OzSVt73MpoVG3OD","input":"_3x1pTPkAuRtkXO-Dw3R2c_","required":"_1G7OTp0o3LdcvmX_pRW-WI","checkboxInput":"_3ZK3oMlpCV2Egb9dT_MYML","checkBox":"VI1u19XiEChQt4jeizf7x","checkboxLabel":"_3nyUb1HJ6ij1SZpFEWAVde"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InputForms/style.css
// module id = 271
// module chunks = 0